const guardedStorage = (kind) => ({
  getItem(key) { try { return window[kind].getItem(key); } catch { return null; } },
  setItem(key, value) { try { window[kind].setItem(key, value); return true; } catch { return false; } },
  removeItem(key) { try { window[kind].removeItem(key); return true; } catch { return false; } },
});

export const safeLocalStorage = guardedStorage("localStorage");
export const safeSessionStorage = guardedStorage("sessionStorage");
